import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SinguralPipe } from './singural.pipe';

@NgModule({
  declarations: [SinguralPipe],
  imports: [CommonModule],
  exports: [SinguralPipe],
})
export class SinguralPipeModule { }
